import { Box } from '@mui/material';
import { ReactElement } from 'react';
import { RiLock2Line } from 'react-icons/ri';
import { Link } from 'react-router-dom';
import { WsColors, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';
interface AccessControlProps {
  errorText?: string;
  icon?: ReactElement;
  hideNavigation?: boolean;
}

export const accessDeniedNotoficationTxt = `You do not have enough permissions to access this page, please contact workspace administrator`;

const AccessControl = ({
  errorText = accessDeniedNotoficationTxt,
  icon = <RiLock2Line color={WsColors.TheBlues500} size={70} />,
  hideNavigation = false,
}: AccessControlProps) => (
  <Box bgcolor={WsColors.White} pb={4} borderRadius={2}>
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        gap: 3,
        mx: '25%',
        py: '10%',
      }}
    >
      <Box>{icon}</Box>
      <Box textAlign="center" pb={2}>
        <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.SECONDARY} bold>
          {errorText}
        </WsTypography>
      </Box>
      {!hideNavigation && (
        <Box component={Link} color={WsColors.TheBlues900} to={'/home'}>
          Go To Home Page
        </Box>
      )}
    </Box>
  </Box>
);

export default AccessControl;
